// extracted by mini-css-extract-plugin
module.exports = {"container":"Zvsx2niL4Q1WeED0-WIDI"};